export namespace AppConstants {
  export var AppKey = "TheApp";
  export var Title = "App";
  export var SubTitle = "SubApp";
  export var Version = "1.0.0";

  export var Http = {
    BaseUrl: window['appSettings'].BaseUrl,
    BaseODataUrl: window['appSettings'].BaseODataUrl,
    Headers: {},
    AuthorizationHeader: false
  };

  export class Routes {
    public static RequestMain = "RequestMain";
    public static Finish = "Finish";
    public static Approve = "Approve";
    public static GreenRoute = "GreenRoute";
    public static GreenRouteForm = "GreenRouteForm";
    public static RedRoute = "RedRoute";
    public static RedRouteQuestions = "RedRouteQuestions";
    public static RedRouteContinue = "RedRouteContinue";
    public static RedRouteBeforeContinue = "RedRouteBeforeContinue";
    public static ResidentApprovalPdf = "ResidentApprovalPdf";
    public static ResidentCompleteRequestDetails ="ResidentCompleteRequestDetails";
  }

  export class HttpMethods {
    public static Get = "GET";
    public static Post = "POST";
    public static Put = "PUT";
  }

  export class Roles {
    public static Admin = "Admin";
    public static System = "System";
    public static Resident = "Resident";
    public static Employee = "Employee";
  }

  export class QuestionCodes {
    public static RentQuestion = "RentQuestion";
    public static RentQuestion2 = "RentQuestion2";
    public static WorkPlaceAreaQuestion = "WorkPlaceAreaQuestion";
    public static WorkPlaceAreaPartnerQuestion = "WorkPlaceAreaPartnerQuestion";
    public static FullAdditionalCondition = "FullAdditionalCondition";
    public static PartialAdditionalConsition = "PartialAdditionalConsition";
    public static UploadFileFinalStep = "UploadFileFinalStep";
    public static RestrictConditionFinalStep = "RestrictConditionFinalStep";
    public static FromStep = "FormStep";
    public static StudentQuestion = "StudentQuestion";
    public static SecurityForceQuestion = "SecurityForceQuestion";
    public static SelfEmployed = "SelfEmployed";
    public static EducationApprovement = "EducationApprovement";
    public static Pensioner = "Pensioner";
  }

  export class Lanes {
    public static Red = "Red";
    public static Green = "Green";
  }

  export class RequestStatus {
    public static InProcess = "InProcess";
    public static IncompleteDetails = "IncompleteDetails";
    public static AfterCompleteDetails = "AfterCompleteDetails";
    public static Approved = "Approved";
    public static Rejected = "Rejected";
    public static InIRSCheck = "InIRSCheck";
    public static Paid = "Paid";
    public static New = "New";
  }

  export class FileToUploadCodes {
    public static EmploymentApprovment = "EmploymentApprovment";
    public static TravelApprovment = "TravelApprovment";
    public static EmploymentApprovmentPartner = "EmploymentApprovmentPartner";
    public static TravelApprovmentPartner = "TravelApprovmentPartner";
    public static AdditionalApprovment = "AdditionalApprovment";
    public static RentLease = "RentLease";
    public static Id = "ID";
    public static ManuallRequest = "ManuallRequest";
    public static SecurityForces = "SecurityForces";
    public static SecurityForcesPayCheck = "SecurityForcesPayCheck";
    public static StudentApprovment = "StudentApprovment";
  }

  export class BaseItemsParentCodes {
    public static FamilyStatus = "FamilyStatus";
    public static KupatHolim = "KupatHolim";
    public static FileType = "FileType";
    public static FileStatus = "FileStatus";
    public static PayMethod = "PayMethod";
    public static WorkPlaceArea = "WorkPlaceArea";
    public static ActivityType = "ActivityType";
    public static LogCategory = "LogCategory";
    public static RequestStatus = "RequestStatus";
  }

  export class FileStatusCodes {
    public static Rejected = "Rejected";
    public static Approved = "Approved";
    public static Uploaded = "Uploaded";
  }

  export class PayMethodsCodes {
    public static Arnona = "Arnona";
    public static Cache = "Cache";
    public static CreditCard = "CreditCard";
    public static CityPay = "CityPay";
  }

  export class LogCategoryCodes {
    public static Regular = "Regular";
    public static PayAttention = "PayAttention";
    public static Important = "Important";
  }

  export const MaxUploadSize = 10485760;
}
